<style>
  .indexBox{
    width:1440px;
    height:auto;
    padding:20px 0;
    margin:0 auto;
  }
  .indexLeft{
    width:300px;
    height:auto;
    min-height:1000px;
    float:left;
  }
  .indexRight{
    width:1050px;
    height:auto;
    min-height:1000px;
    position: relative;
    float:left;
    margin-left:90px;
  }
  .indexRightTop{
    width:100%;
    height:30px;
    position: relative;
  }
  .searchBox{
    width:786px;
    height:30px;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 6px rgba(153,152,155,0.16);
    opacity:1;
    border-radius:50px;
    float:left;
    position: relative;
  }
  .searchLogo{
    position: absolute;
    height:28px;
    width:28px;
    top:1px;
    left:15px;
  }
  .searchLogo img{
    heigth:100%;
    width:100%;
  }
  .searchBox input{
    position: absolute;
    width:100%;
    height:30px;
    line-height: 30px;
    font-size:13px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(153,153,153,1);
    left:0;
    top:0;
    background: none;
    border:none;
    padding:0 60px;
  }
  input:focus, textarea:focus, select:focus {
      outline-offset: 0;
  }
  :focus {
      outline:none;
  }
  .searchClear{
    width:10px;
    height:10px;
    position: absolute;
    right:40px;
    top:10px;
    cursor: pointer;
  }
  .searchBtn{
    height:20px;
    width:20px;
    position: absolute;
    right:10px;
    top:5px;
    cursor: pointer;
  }
  .countBox{
    position: relative;
    float:right;
    width:260px;
    height:30px;
    font-size:15px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:30px;
    color:rgba(51,51,51,1);
    opacity:1;
    text-align: right;
  }
  .locationBox{
    height:25px;
    width:100%;
    /* position: relative; */
    margin:19px 0 30px;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:25px;
    color:rgba(51,51,51,1);
    text-align: left;
    padding-left:15px;
  }
  .locationBox span{
    color:rgba(81,71,231,1);
    margin-left:15px;
    cursor: pointer;
  }
  .locationBox .chooseCity{
    display: inline-block;
    position: relative;

  }
  .locationBox .chooseCity .chooseBox{
    position: absolute;
    left: 15px;
    top: 30px;
    width:440px;
    height:228px;
    background:rgba(52,51,52,1);
    box-shadow:0px 3px 6px rgba(0,0,0,0.16);
    opacity:0.95;
    border-radius:8px;
    z-index: 1;
    color:rgba(255,255,255,1);
    padding: 10px 12px;
    font-weight: 400;
    font-size: 15px;
  }
  .locationBox .chooseCity .chooseBox p{
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 400;
  }
  .selectBox select{
    margin-top: 16px;
    background-color: rgba(52,51,52,1);
    border:1px solid rgba(255,255,255,1);
    opacity:1;
    border-radius:6px;
    font-weight:500;
    font-size: 16px;
    height: 30px;
    color:rgba(214,214,214,1);
    cursor: pointer;
  }
  .selectBox select:nth-child(2){
    width: 212px;
  }
  .selectBox select:nth-child(3){
    width: 179px;
  }
  .chooseCity .hotCity{
    margin-top: 20px;
  }
  .chooseCity .hotCity ul{
    display: flex;
    flex-flow: wrap;
    /* padding: 10px; */
    padding-top: 10px;
  }
  .chooseCity .hotCity ul li{
    list-style: none;
    width: 58px;
    text-align: center;
    cursor: pointer;
    padding-bottom: 10px;
  }
  .chooseCity .hotCity ul li:hover{
    color: #F36800;
  }
  .cursor{
    cursor:pointer;
  }
  .factoryList{
    width:100%;
    position: relative;
    height: auto;
  }
  .mobile_locationBox {
  	display: none;
  }
  .mobile_menu {
  	display: none;
  }
  .mobile_menu_all {
  	display: none;
  }
  .locationBox .toMap{
    float: right;
    font-size: 16px;
  }
  .meng{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  @media screen and (max-width:500px ) {

  	.indexBox {
  		width: 100%;
  	}

  	.indexBox .indexLeft {
  		display: none;
  	}
  	.indexBox .indexRight {
  		width: 96%;
  		min-height: auto;
  		margin-left: 2%;
  		margin-top: 40px;
  	}
  	.indexBox .searchBox{
	    width:50%;
	    height:30px;
	    background:rgba(255,255,255,1);
	    box-shadow:0px 1px 6px rgba(153,152,155,0.16);
	    opacity:1;
	    border-radius:50px;
	    float:right;
	    position: relative;
	  }
	  .indexBox .searchBox input {
	  	width: 100%;
	  	padding: 0;
	  	padding-left: 10px;
	  }
  	.indexBox .countBox{
	    position: relative;
	    float:right;
	    width:260px;
	    height:30px;
	    font-size:12px;
	    line-height:30px;
	    color:#666666;
	    text-align: right;
	    margin-right: 10px;
	  }
	  .indexBox .locationBox {
	  	display: none;
	  }
	  .searchLogo {
	  	display: none;
	  }
	  .indexBox .mobile_locationBox {
	  	display: inline-block;
	  	position: relative;
			font-size: 13px;
	  	top: 6px;
	  	margin-left: 120px;
	  	color: #5147E7;
	  }
	  .indexBox .factoryList{
	    width:100%;
	    position: relative;
	    height: auto;
	    margin-top: 30px;
	  }
	 .indexBox .factoryList .factoryListNext {
	 	 	margin-right: 10px;
	 }
	 .indexBox .mobile_menu {
		 	position: absolute;
		 	display: inline-block;
		 	font-size: 15px;
		 	font-weight: Bold;
		 	top: 5px;
		 	left: 7px;
		}
		.indexBox .mobile_menu > img {
			position: relative;
			top: -2px;
		}
		.indexBox .mobile_menu_all {
				position: absolute;
		 		display: inline-block;
		 		font-size: 15px;
		 		top: 36px;
		 		left: 7px;
		 		border-radius:8px ;
		 		width: 135px;
		 		height: 405px;
		 		/*background-color: rgba(10,10,10,0.9);*/
		 		z-index: 900;
		}
		.indexBox .mobile_menu_all img {
				position: absolute;
				top: -10px;
				width: 135px;
		 		height: 405px;
		 		z-index: 500;
		}
		.indexBox .mobile_menu_all > span {
			display: inline-block;
			position: relative;
			width: 100%;
			height: 50px;
			line-height: 50px;
			color: #FFFFFF;
			z-index: 600;
			border-bottom:1px solid rgba(122,122,122,1);
		}
  }


</style>

<template>
  <div class='indexBox'>
    <!-- <project></project> -->
    <div class='indexLeft'>
      <!--<userInfo v-if='userData.id!=-1'></userInfo>-->
      <userInfo @changeNavInfo="changeNav" :userInfo='userData' v-if='userData.id'></userInfo>
      <notLogin v-if='!userData.id'></notLogin>
      <identitySelect @changeIdentity='changeIdentity'></identitySelect>
    </div>
    <modifiedData :userInfo='userData' @changeNavInfo="changeNav" v-if="changenav == 'modified' && userData.id"></modifiedData>
    <div class='indexRight'  v-if="changenav == 'guiguiFactory'">
      <div class='indexRightTop'>
        <div class='searchBox'>
          <div class='searchLogo'>
            <img src="../assets/searchlogo.png" alt="">
          </div>
          <input type="text" v-model='keyword'>
          <img src="../assets/searchclose.png" alt="" class='searchClear' v-show='keyword!=""' @click='keyword=""'>
          <img src="../assets/searchbtn.png" alt="" class='searchBtn' @click='searchKeyword'>
        </div>
        <div class="mobile_menu">
        	<span @click="showMenuOut">{{showMenuNow.name}}({{showMenuNow.count}})</span>
        	<img src="../assets/icon_zhankai_zhanting.png" v-if="!showMenu" alt="" /><img src="../assets/icon_shouqi_zhanting.png" v-if="showMenu" alt="" />
        </div>
        <div class="mobile_menu_all" v-if="showMenu">
        	<img src="../assets/List_change menu.png" alt="" />
        	<span :data-identity='item.identity' @click='changeIdentityChoose'  v-for="(item,index) in identityList">{{item.name}}({{item.count}})</span>
        </div>
        <div class="mobile_locationBox">
	      	 <span @click='location'>{{city||"定位"}}</span>
	      </div>
        <div class='countBox' v-show='count.all!=0'>
          今日访客: {{todayCount}}&nbsp;&nbsp;&nbsp;累计: {{allCount}}
        </div>
      </div>
      <div class='locationBox'>
        当前城市: {{city||"全国"}}
        <span @click='location'>定位</span>
        <div class="meng" v-if="cityMenu" @click="cityMenu = false"></div>
        <div class="chooseCity">
          <span @click="chooseCity">选择城市</span>

          <div v-if='cityMenu' class="chooseBox">
            <div class="selectBox">
              <p><label>选择城市</label><label class="cursor" @click="chooseCity"><img src="../assets/icon_chacha.png" alt=""></label></p>
              <select @change="cityChange($event)">
                <option selected disabled>请选择省市</option>
                <option v-for="(item,index) in cityInfo.proviceName" :value="item">{{item}}</option>
              </select>
              <select @change="serchCity($event)">
                <option selected disabled>请选择城市</option>
                <option v-for="(item,index) in cityInfo.cityName" :value="item">{{item}}</option>
              </select>
            </div>
            <div class="hotCity">
              <p>热门城市</p>
              <ul>
                <li @click="toSearchCity(item.city)" v-for="item in cityInfo.hotCity">{{item.city}}</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <span class="toMap" @click="toMap">全球分布地图 ></span> -->
      </div>
      <div class='factoryList'>
        <factory v-for='(item,index) in factory' :info='item' :key="index"></factory>
        <div class="factoryListNext" style="text-align: right;">
          <el-button plain v-show='page!=1' @click='changePage' data-add='-1'>上一页</el-button>
          <el-button plain v-show='page<totalPage' @click='changePage' data-add='1'>下一页</el-button>
        </div>
      </div>
    </div>
    <div style="clear:both"></div>
  </div>
</template>

<script>
  import project from '../components/Project.vue'
  import factory from '../components/Factory.vue'
  import userInfo from '../components/UserInfo.vue'
  import notLogin from '../components/NotLogin.vue'
  import identitySelect from '../components/IdentitySelect.vue'
  import modifiedData from '../components/modifiedData.vue'

    import autoLogin from '../util/autoLogin.js'
import { mapState, mapMutations } from 'vuex'
  export default {
    components: {
      project,
      factory,
      identitySelect,
      userInfo,
      modifiedData,
      notLogin
    },
    props: [],
    data() {
      return {
        // userData:{id:-1},
        count: {
          today: 0,
          all: 0,
        }, //访问量
        keyword: "", //关键词搜索
        showMenu:false,	// 显示弹框
        cityMenu:false,
        cityInfo:{
          allinfo:[],
          proviceName:[],
          cityName:[],
          hotCity:[]
        },
        showMenuNow:{
        	name:'',
        	count:0
        }, // 当前显示
        city: "",
        page: 1, //分页
        totalPage: 1, //总页数
        factory: [], //工厂列表
        identity:3,//身份选择
        changenav:'guiguiFactory',
        identityList:[{
          identity:3,
          name:"柜柜工厂",
          count:"…"
        },{
          identity:2,
          name:"门店",
          count:"…"
        },{
          identity:1,
          name:"木工",
          count:"…"
        },{
          identity:5,
          name:"设备商",
          count:"…"
        },{
          identity:6,
          name:"材料厂",
          count:"…"
        },{
          identity:4,
          name:"柜门厂",
          count:"…"
        },{
          identity:7,
          name:"软件服务点",
          count:"…"
        },{
          identity:8,
          name:"其他",
          count:"…"
        }]
      }
    },
    computed: {
      ...mapState({
        userData: 'userInfo'
      }),
      todayCount() {
        let that = this
        if (that.count.today >= 10000) {
          let today = (that.count.today / 10000).toFixed(1)
          return "" + today + "w"
        } else {
          return "" + that.count.today + "人"
        }
      },
      allCount() {
        let that = this
        if (that.count.all >= 10000) {
          let all = (that.count.all / 10000).toFixed(1)
          return "" + all + "万"
        } else {
          return "" + that.count.all + "人"
        }
      }
    },
    mounted :async function() {
      let that = this
      // console.log(1)

      // app已经做过自动登录了，不在这里再做一遍
      // if (that.GetQueryString('p')) {
      //   // console.log(2)
      //   await autoLogin.autoLogin(that.GetQueryString('p'), that.GetQueryString('en'))
      // }
      // if (localStorage.getItem('data')) {
      //   that.userData = JSON.parse(localStorage.getItem('data'))
      //   that.$emit("logon")
      // }
      // console.log(that.userData)
      that.$get("/guigui/exhibition/getFactoryGroupCount", {}, res => {
        that.count = res.data
      })
      that.search()
      await that.$get('/guigui/exhibition/identityCount',{},res=>{
        let data=res.data
				 for(let key  in data){
                let list=that.identityList
				        for(let i=0,len=list.length;i<len;i++){
                  if(key==list[i].identity){
                    that.identityList[i].count=data[key]
                  }
                }
				 }
		      that.showMenuNow.name = that.identityList[0].name
				  that.showMenuNow.count = that.identityList[0].count
      })
      that.$post('/guigui/user/all_city',{'version':1}, res => {
        let data = res.data.all;
        that.cityInfo.allinfo = res.data.all;
        that.cityInfo.hotCity = res.data.hot;
        // data.forEach((e,i) => {
        //   if(that.cityInfo.proviceName.indexOf(e.province) == -1){
        //     that.cityInfo.proviceName.push(e.province)
        //   }
        // })
      })
    },
    methods: {
      initPage(){
        this.page = 1
      },
    	showMenuOut() {
    		let that = this
    		if(that.showMenu == true){
    			that.showMenu = false
    			return
    		}
    		that.showMenu = true
    	},
    	changeIdentityChoose(e){
    		let that = this
				let identity=parseInt(e.currentTarget.dataset.identity)
				if(this.now==identity){
				  return
				}
				for(let i = 0; i<that.identityList.length;i++) {
					if(identity == that.identityList[i].identity) {
						that.showMenuNow.name = that.identityList[i].name
						that.showMenuNow.count = that.identityList[i].count
						break
					}
				}
				// console.log(identity)
				this.now=identity
				that.showMenu = false
				that.changeIdentity(identity)
		  },
      // logout(){
      //   this.userData={
      //     id:-1
      //   }
      // },
      GetQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg); //search,查询？后面的参数，并匹配正则
        if (r != null) return unescape(r[2]);
        return null;
      },
      changeIdentity(identity){
        this.page = 1
        let that=this
        that.identity = identity
        that.changenav='guiguiFactory'
        console.log(2)
        that.search()
      },
      changePage(e) {
        let that = this
        let add = parseInt(e.currentTarget.dataset.add)
        that.page += add
        that.search()
      },
      searchKeyword() {
        let that = this
        that.page = 1
        that.search()
      },
      changeNav(changenav){
				let that = this
          // console.log("change")
			    if (changenav != that.changenav) {
					that.changenav = changenav
				}
			},
      search() {
        let that = this
        that.$post("/guigui/exhibition/identityList", {
          identity:that.identity,
          page: that.page,
          keyword: that.keyword,
          city: that.city
        }, res => {
          // console.log(res)
          if(!res.data){
            that.page =1
            that.totalPage=1
            that.factory =[]
            return
          }
          that.factory = res.data.list
          that.page = res.data.current_page
          that.totalPage = res.data.totalPage
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        })
        // console.log(3)
      },
      location() {
        let that = this
        var citysearch = new AMap.CitySearch();
        citysearch.getLocalCity(function(status, result) {
          if (status === 'complete' && result.info === 'OK') {
            if (result && result.city && result.bounds) {
              var cityinfo = result.city;
              var citybounds = result.bounds;
              var reg = /^.*市$/
              // console.log(cityinfo)
              if (reg.test(cityinfo)) {
                cityinfo = cityinfo.substring(0, cityinfo.length - 1)
              }
              // console.log(cityinfo)
              that.city = cityinfo
              that.$message({
                message: "定位成功",
              })
              that.keyword = ""
              that.page = 1
              that.search()
            }
          } else {
            that.$message({
              showClose: true,
              message: "定位失败",
              type: 'error'
            })
          }
        });
      },
      chooseCity(){
        // console.log(this.cityInfo.allinfo)
        if(!this.cityMenu){
          this.cityMenu = true;
          this.cityInfo.allinfo.forEach((e,i) => {
          if(this.cityInfo.proviceName.indexOf(e.province) == -1){
            this.cityInfo.proviceName.push(e.province)
          }
        })
        }else{
          this.cityMenu = false
        }
      },
      cityChange(e){
        let province = e.target.value
        this.cityInfo.cityName = []

        this.cityInfo.allinfo.forEach((item,index) => {
          if(province == item.province){
            this.cityInfo.cityName = item.city
          }
        })

      },
      serchCity(e){
        this.city = e.target.value;
        this.keyword = '';
        this.page = 1;
        this.search()
        this.$message({
          message:'定位成功',
          type:'success'
        })
        this.cityMenu = false
      },
      toSearchCity(cityname){
        this.city = cityname;
        this.keyword = '';
        this.page = 1;
        this.search()
        this.$message({
          message:'定位成功',
          type: 'success'
        })
        this.cityMenu = false;
      },
      toMap(){
        // this.$emit('changeNow','全球分布')
        // this.$message({
        //   message:'功能开发中',
        //   duration: 1000
        // })
      }
    }
  }
</script>
